//image toggle on/off
$(".celladix_toggle .image_toggle_box02 .image_toggle_cont button").on("click", function(){
    if($(this).parent().hasClass("on")){
        $(this).parent().removeClass("on");
        $(".image_toggle_cont button").css("z-index","20");
        $(".image_toggle_box02").removeClass("open");
    }else{
        $(".image_toggle_cont li").removeClass("on");
        $(this).parent().addClass("on");
        $(".image_toggle_cont button").css("z-index","1");
        $(this).css("z-index","100");
        $(".image_toggle_box02").addClass("open");
    }
});